if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          this.toggle.removeAttribute('open');
          this.toggle.classList.remove('active');
        }
      });

      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }

      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => this.toggle.classList.add('active'));
        }
      });

      this.updateHeaderVars();
      window.addEventListener('resize', debounce(() => this.updateHeaderVars(), 150), { passive: true });

      this._rafPending = false;
      this._wasSticky = null;

      this._onScroll = () => {
        if (this._rafPending) return;
        this._rafPending = true;

        requestAnimationFrame(() => {
          this._rafPending = false;

          if (!this.classList.contains('header-sticky--active')) return;

          const isSticky = window.scrollY > 0;

          if (isSticky === this._wasSticky) return;

          this._wasSticky = isSticky;
          this.classList.toggle('is-sticky', isSticky);
          this.updateHeaderVars();
        });
      };

      window.addEventListener('scroll', this._onScroll, { passive: true });

      const initSticky = () => {
        if (!this.classList.contains('header-sticky--active')) return;
        const isSticky = window.scrollY > 0;
        this._wasSticky = isSticky;
        this.classList.toggle('is-sticky', isSticky);
      };
      initSticky();

      if (document.querySelector('.announcement-bar-section')) {
        this.setAnnouncementHeight();
        window.addEventListener('resize', debounce(() => this.setAnnouncementHeight(), 150), { passive: true });
      }

      setTimeout(() => {
        this.mobile_nav = document.querySelector('.header-mobile-navigation');
        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);

      this.menu.querySelectorAll('summary').forEach(s => s.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(b => b.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    updateHeaderVars() {
      const headerHeight = this.clientHeight;
      const sectionTop = this.header_section ? this.header_section.getBoundingClientRect().top : 0;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      document.documentElement.style.setProperty('--header-offset', sectionTop + 'px');
    }

    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      if (!a_bar) return;
      document.documentElement.style.setProperty('--announcement-height', a_bar.clientHeight + 'px');
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }

    onCloseButtonClick(event) {
      event.preventDefault();
      this.closeSubmenu(event.currentTarget.closest('details'));
    }

    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;
      const handleAnimation = (time) => {
        if (animationStart === undefined) animationStart = time;
        if (time - animationStart < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };
      window.requestAnimationFrame(handleAnimation);
    }
  }

  customElements.define('theme-header', ThemeHeader);
}

if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }

    connectedCallback() {
      if (!this.submenus.length) return;
      const _this = this;
      document.fonts.ready.then(function () {
        window.addEventListener('resize', debounce(function () {
          _this.resizeSubMenus();
        }, 100));
      });
    }

    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu').forEach((sub_submenu) => {
          const w = sub_submenu.offsetWidth;
          const l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth;
          if (w + l > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }

  customElements.define('full-menu', FullMenu);
}